import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function MenuButton(
    {
      path,
      currentPath,
      onClick,
      icon: Icon,
      label,
      iconfirst = true,
      afterClickingChange = true,
      borders = null,
      bordersClassPrefix = 'border-gray-',
      showLabel = true,
      showSpeechBubble = true,
      disabled = false,
      lockIcon: LockIcon}) {
  const isActive = currentPath === path;

    // Generowanie klasy dla ramek na podstawie `borders`
    const borderClass = borders
    ? borders
        .split('')
        .map((char) => `${bordersClassPrefix}${char}`)
        .join(' ')
    : '';

    const menuClassName = `${!afterClickingChange ? 'menu-item' : isActive ? 'menu-item-actual' : 'menu-item'} ${borderClass}`.trim();
    const content = (
      <span className="menu-icon-wrapper">
        {iconfirst ? Icon && <Icon className={ showLabel ? (label === ''  ? 'menu-icon-without-text' : 'menu-icon') : 'menu-icon-without-text-2'} /> : label}
        {showLabel ? iconfirst ? label : Icon && <Icon className={label === '' ? 'menu-icon-without-text' : 'menu-icon'} /> : ''}
        {showSpeechBubble && <span className="menu-tooltip">{label}</span>}
        {disabled && LockIcon && <LockIcon className="menu-lock-icon" />}
      </span>
    );

    if (disabled) {
      return (
        <span
          className={`${menuClassName} menu-item-disabled`}
          aria-disabled="true"
          title={showSpeechBubble ? label : undefined}
        >
          {content}
        </span>
      );
    }

    return (
      <Link
        to={path}
        className={menuClassName}
        onClick={() => onClick(path)}
        title={showSpeechBubble ? label : undefined}
      >
        {content}
      </Link>
    );
  }

  MenuButton.propTypes = {
    path: PropTypes.string.isRequired, // Ścieżka do nawigacji
    currentPath: PropTypes.string.isRequired, // Aktualna ścieżka
    onClick: PropTypes.func.isRequired, // Funkcja obsługi kliknięcia
    icon: PropTypes.elementType, // Ikona jako komponent React
    label: PropTypes.string.isRequired, // Etykieta przycisku
    iconfirst: PropTypes.bool, // Czy ikona ma być wyświetlana przed etykietą
    afterClickingChange: PropTypes.bool, // Czy klasa ma się zmieniać po kliknięciu
    borders: PropTypes.string, // Ciąg znaków definiujący ramki (np. "LRBT")
    showLabel: PropTypes.bool,
    showSpeechBubble: PropTypes.bool,
    disabled: PropTypes.bool,
    lockIcon: PropTypes.elementType,
  };
  
  MenuButton.defaultProps = {
    iconfirst: true, // Domyślnie ikona jest wyświetlana przed etykietą
    afterClickingChange: true, // Domyślnie klasa zmienia się po kliknięciu
    borders: null, // Domyślnie brak ramek
    showLabel: true,
    showSpeechBubble: true,
    disabled: false,
    lockIcon: undefined,
  };
  
  export default MenuButton;
